export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.506bc821.ttf";